<template>
<div id="purchasable-items">
  <h2>Purchasable Items</h2>

  <purchasable-item-nav
  ></purchasable-item-nav>

  <purchasable-item-search
  ></purchasable-item-search>

  <hr />

  <pagination
    :resourceUrl="this.apiUrl('/purchasable_items')"
    :pageResponse="pageResponse"
    :pageSize="$root.defaultPageSize"
    orderBy="visible_at"
    orderType="DESC"
  >
    <template
      slot="paged_item"
      slot-scope="item"
    >
      <router-link
        :class="$root.listItemClasses"
        :to="{
          name: 'purchasable_item',
          params: { purchasableItemId: item.id }
        }"
      >
        {{ item.name }}
      </router-link>
    </template>
  </pagination>
</div>
</template>

<script>
import Pagination from 'sai-vue-kaminari'

import PurchasableItemNav from '@/components/PurchasableItemNav'
import PurchasableItemSearch from '@/components/PurchasableItemSearch'

export default {
  components: {
    pagination: Pagination,
    'purchasable-item-nav': PurchasableItemNav,
    'purchasable-item-search': PurchasableItemSearch
  },

  data () {
    return {
      pageResponse: {}
    }
  },

  created () {
    this.$on('searchComplete', this.onPageSuccess)
  },

  methods: {
    onPageSuccess (resp) {
      this.pageResponse = resp
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/PurchasableItems.vue